export default __webpack_public_path__ + "static/media/success.008ac682.svg";